var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M9.379 2.356V1.07A.43.43 0 0 0 8.95.642h-.857a.43.43 0 0 0-.429.428v1.286H4.236V1.07a.43.43 0 0 0-.429-.428H2.95a.43.43 0 0 0-.429.428v1.286H1.236c-.71 0-1.286.576-1.286 1.286v1.285h12V3.642c0-.71-.576-1.286-1.286-1.286zM1.664 7.927a.43.43 0 0 1 .429-.428h2.571a.43.43 0 0 1 .429.428V10.5a.43.43 0 0 1-.429.428H2.093a.43.43 0 0 1-.429-.428zM-.05 13.07c0 .71.576 1.286 1.286 1.286h9.428c.71 0 1.286-.576 1.286-1.286V5.784h-12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.c1b1d18b62e3cdba9792098d11033b1f.svg";
export { ForwardRef as ReactComponent };